import React, { useEffect } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import ServicePage from '../pages/ServicePage/ServicePage.tsx';
import ProductPage from '../pages/ProductPage/ProductPage.tsx';
const HomePage = React.lazy(() => import('../pages/HomePage/HomePage.tsx'));
const AboutUsPage = React.lazy(() => import('../pages/AboutUsPage/AboutUsPage.tsx'));
const ContactUsPage = React.lazy(() => import('../pages/ContactUsPage/ContactUsPage.tsx'));

export default function UserRoutes() {
    const location = useLocation();

    /* Scrolls to the top of the page on pathname changes, ignoring query parameters. */
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo({
                top: (location.pathname === "/") ? 0 : window.innerHeight,
                behavior: 'smooth'
            });
        }, 100); // Delay is added to ensure that the page is rendered before scrolling
    }, [location.pathname]);

    const list = {
        children: [
            { path: '/', element: <HomePage/> },
            { path: '/about-us', element: <AboutUsPage/> },
            { path: '/contact-us', element: <ContactUsPage/> },
            { path: '/products/:productName', element: <ProductPage/> },
            { path: '/services/:serviceName', element: <ServicePage/> },
            { path: '*', element: <HomePage/> }
        ],
    };

    return useRoutes([list]);
};